import { AlertFilterKeyString } from 'AlertsOfVulnerability/types'
import { METADATA_INITIAL_FILTER } from 'components/filters/MetadatasFilterTemplate/constants'
import { CITIZEN_FIELDS_INITIAL_VALUES } from 'CitizenProfile/constants/pages/citizens'
import { ALERT_TYPE_FIELDS_INITIAL_VALUES } from '../alertsTypes'

export const ALERT_INITIAL_FILTER: AlertFilterKeyString = {
  search: '',
  ...ALERT_TYPE_FIELDS_INITIAL_VALUES,
  ...METADATA_INITIAL_FILTER,
  ...CITIZEN_FIELDS_INITIAL_VALUES,
  responsable_person_id: '',
  is_valid_status: true,
  case_type_id: [],
}
